import { generateFilesQueryKey } from 'dataLayer/queryKeys';
import { errorHandler } from 'helpers/utils';
import { ChangeEvent } from 'react';
import { useQueryClient, useMutation } from 'react-query';

export const useS3FileUploadMutation = (
  fileUploadHandler: (event: ChangeEvent<HTMLInputElement>) => Promise<void>,
  dealId: string,
  fileType: string,
) => {
  const qc = useQueryClient();

  return useMutation<void, unknown, ChangeEvent<HTMLInputElement>>(
    fileUploadHandler,
    {
      onError: (err) => {
        errorHandler(err);
      },
      onSettled: () => {
        qc.invalidateQueries(generateFilesQueryKey(dealId, fileType));
      },
    },
  );
};
